import { Tag } from "../../types/Tag";

import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

interface TagFormProps {
    tag: Tag;
    onTagChange: (tag: Tag) => void;
    onSubmit: () => Promise<boolean>;
    onCancel: () => void;
}

const TagForm: React.FC<TagFormProps> = ({ tag, onTagChange, onSubmit, onCancel }) => {
    const [nameError, setNameError] = React.useState<string>("");
    const [descriptionError, setDescriptionError] = React.useState<string>("");

    function onNameChange(label: string) {
        onTagChange({ ...tag, label });
        setNameError("");
    }

    function onDescriptionChange(description: string) {
        onTagChange({ ...tag, description });
        setDescriptionError("");
    }

    async function handleFormSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        let error: boolean = false;
        if (!tag.label) {
            error = true;
            setNameError("Name cannot be empty");
        }
        if (tag.label.length > 50) {
            error = true;
            setNameError("Name cannot be longer than 50 characters");
        }
        if (tag.description.length > 500) {
            error = true;
            setDescriptionError("Description cannot be longer than 500 characters");
        }
        if (!/^[a-zA-Z 0-9.,+-]*$/.test(tag.label)) {
            error = true;
            setNameError("Name cannot contain special characters");
        }
        if (error) {
            console.log("error");
            return;
        }
        const success = await onSubmit();
        if (!success) {
            setNameError("Tag already exists");
        }
    }

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
            onSubmit={handleFormSubmit}
            onReset={onCancel}
            sx={{ display: "grid" }}
        >
            <TextField
                id="tag-name"
                name="tag-name"
                label="Tag name"
                error={!!nameError}
                helperText={nameError}
                value={tag.label}
                onChange={(event) => onNameChange(event.target.value)}
                fullWidth
                margin="normal"
                sx={{
                    ".MuiInputBase-input": { fontSize: "large" },
                }}
            />
            <TextField
                id="tag-description"
                name="tag-description"
                label="Tag description"
                multiline
                error={!!descriptionError}
                helperText={descriptionError}
                value={tag.description}
                onChange={(event) => onDescriptionChange(event.target.value)}
                fullWidth
                margin="normal"
                minRows={5}
                sx={{
                    ".MuiInputBase-input": { fontSize: "large" },
                }}
            />
            <Stack direction="row" spacing={2}>
                <Button type="reset">Cancel</Button>
                <Button type="submit">Post</Button>
            </Stack>
        </Box>
    );
};

export default TagForm;
